import React, { useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { globalTheme } from '../../theme';
import ScopedCssBaseline from '@mui/material/ScopedCssBaseline';
import ScopedCssBaselineV4 from '@material-ui/core/ScopedCssBaseline';
import { globalTheme as globalThemeV4 } from '@next-common/material-ui';
import { ThemeProvider as ThemeProviderV4 } from '@material-ui/core';
import { StylesProvider, jssPreset, createGenerateClassName } from '@material-ui/core/styles';
import { create } from 'jss';
import { prefixwrap } from './jss-plugin-prefixwrap';
import '@mui/styles';
const jss = create({
    plugins: jssPreset().plugins,
});
let prefixwrapJssPluginLoaded = false;
const GenerateClassNameModuleMap = new Map();
const getGenerateClassNameModule = (moduleName = 'jss') => {
    if (typeof window === 'undefined') {
        return createGenerateClassName({ productionPrefix: moduleName.substr(0, 3), disableGlobal: true });
    }
    if (GenerateClassNameModuleMap.has(moduleName)) {
        return GenerateClassNameModuleMap.get(moduleName);
    }
    else {
        const generateClassNameModule = createGenerateClassName({
            productionPrefix: moduleName.substr(0, 3),
            disableGlobal: true,
        });
        GenerateClassNameModuleMap.set(moduleName, generateClassNameModule);
        return generateClassNameModule;
    }
};
export const MUIProvider = ({ children, moduleName, muiThemeColor, htmlFontSize, pixToRem, //this is build for hypernova to allow a css calc var based font size ajustment
prefixwrapClassName, }) => {
    useEffect(() => {
        var _a;
        let jssStyles;
        if (moduleName)
            jssStyles = document.querySelector(`#jss-server-side-${moduleName}`);
        else
            jssStyles = document.querySelector('#jss-server-side');
        if (jssStyles) {
            (_a = jssStyles.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(jssStyles);
        }
    }, [moduleName]);
    if (prefixwrapClassName && !prefixwrapJssPluginLoaded) {
        // this is build for hypernova to wrap all css in a ._hy class to address css specificity issues in monolith
        jss.use(prefixwrap({ wrapperClassName: prefixwrapClassName }));
        prefixwrapJssPluginLoaded = true;
    }
    return (React.createElement(StylesProvider, { generateClassName: getGenerateClassNameModule(moduleName), jss: jss, sheetsManager: new Map() },
        React.createElement(ThemeProviderV4, { theme: globalThemeV4(muiThemeColor, htmlFontSize, pixToRem) },
            React.createElement(ScopedCssBaselineV4, null,
                React.createElement(ThemeProvider, { theme: globalTheme(muiThemeColor, htmlFontSize, pixToRem) },
                    React.createElement(ScopedCssBaseline, null, children))))));
};
